import { Box, Button, Dialog, Theme, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react'
import { useHistory, useRouteMatch } from 'react-router';
import { useDispatch } from 'react-redux';
import { resendOtp, validateOtp } from '../../../../redux-store/actions/cart';
import { OtpResponseMessage, ResendOtpResponseBody, ValidateOtpResponseBody } from '../../../../redux-store/types/cart';
import { showError } from '../../../../redux-store/actions/auth';
import OTPForm from '../../../../lib/formik/OtpForm';
import { SuccessIcon } from '../../../../assets/SvgIcons';

export default function CheckandVerifyOtp(): JSX.Element {
    const { url } = useRouteMatch();
    const history = useHistory();
    const { cartId, otpResponseMessages, paymentId } = history.location.state as unknown as { paymentId: string, cartId: string, otpResponseMessages: OtpResponseMessage[]; };
    // const [otpMessage, setOtpMessage] = useState<string>(message ?? '');
    const dispatch = useDispatch();
    const [paymentNotRequired, setPaymentNotRequired] = useState<boolean>(false);
    const [paymentFalseMessage, setPaymentFalseMessage] = useState<string>('');
    const theme = useTheme();


    const handleSubmit = async (otp: string, id: number) => {
        const payload = {
            otp,
            token: paymentId ?? "",
            id: `${id}`,
            cartId: cartId ?? ""
        }

        const response = await (dispatch(validateOtp(payload)) as unknown as Promise<ValidateOtpResponseBody>)
        if (response?.isSuccess) {
            if (response?.cartId) {
                setPaymentNotRequired(true);
                setPaymentFalseMessage(response?.message ?? "");
            } else {
                const otpResponse = otpResponseMessages?.map(item =>
                    item.id === response?.id ? { id: response.id, isVerified: true, message: response?.message } : item
                );
                history.replace({
                    pathname: url,
                    state: { cartId: cartId, otpResponseMessages: otpResponse, paymentId: paymentId }  //updating id in location:state if resend otp is success
                });
            }
        }
        else {
            dispatch(showError(response?.message ?? ""));
        }
    }

    const handleResend = async (id: number) => {
        const payload = {
            cartId: cartId ?? "",
            id: `${id}`,
            token: paymentId ?? ""
        }

        const response = await (dispatch(resendOtp(payload)) as unknown as Promise<ResendOtpResponseBody>)

        if (response?.isSuccess) {
            // setOtpMessage(response?.message ?? "");
            const otpResponse = otpResponseMessages?.map(item =>
                item.id === response?.requestForId ? { ...item, id: response.id, maximum_attempts: response?.maximum_attemps, failed_attempts: response?.failed_attempts, message: response?.message, numberOfOTPTries: response?.numberOfOTPTries } : item
            );
            history.replace({
                pathname: url,
                state: { cartId: response?.cartId ?? "", otpResponseMessages: otpResponse, paymentId: response?.token ?? "" }
                //updating id in location:state if resend otp is success
            });
        }
    }

    const handlePaymentFalsePopup = () => {
        setPaymentNotRequired(false);
        history.replace('/investor-dashboard');
    }

    return (
        <>
            <Box sx={{ padding: '30px 45px' }}>
                <Typography
                    variant="h1"
                    sx={(theme: Theme) => ({
                        lineHeight: "32.5px",
                        color: theme.palette.text.primary
                    })}
                >
                    Transaction Confirmation
                </Typography>
                <Box
                    sx={(theme: Theme) => ({
                        marginTop: "25px",
                        borderRadius: "20px",
                        backgroundColor: theme.palette.common.white,
                        padding: "50px",
                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    })}
                >
                    {/* <Box sx={{ width: "50%" }}>
                        <OTPForm
                            onSubmit={handleSubmit}
                            onResend={handleResend}
                            otpMessage={otpMessage ?? ''}
                            warningMessage=""
                        />
                    </Box> */}
                    {otpResponseMessages?.map((item, idx) => {
                        return (
                            <Box key={idx} sx={{ width: "50%", border: `1px solid ${theme.palette.text.secondary}`, p: 3, borderRadius: '20px' }}>
                                {item.isVerified
                                    ? <Typography>{item.message}</Typography>
                                    : <OTPForm
                                        onSubmit={(otp) => handleSubmit(otp, item.id)}
                                        onResend={() => handleResend(item.id)}
                                        otpMessage={item.message ?? ''}
                                        numberOfTries={item?.numberOfOTPTries ?? 0}
                                        warningMessage=""
                                    />
                                }
                            </Box>)
                    })}
                </Box>
            </Box>
            <Dialog
                onClose={() => setPaymentNotRequired(false)}
                open={paymentNotRequired}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "48px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingTop: "15px",
                            rowGap: "12px"
                        }}
                    >
                        <SuccessIcon />
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                lineHeight: "25px",
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary
                            })}
                        >
                            Success!
                        </Typography>
                        <Typography
                            variant="subtitle_400"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.secondary,
                                textAlign: "center"
                            })}
                        >
                            {paymentFalseMessage}
                        </Typography>
                    </Box>
                    <Box>
                        <Button
                            variant="contained"
                            fullWidth
                            sx={(theme: Theme) => ({
                                borderRadius: "4px",
                                padding: "13px 20px",
                                backgroundColor: theme.palette.primary[500],
                                ...theme.typography.body_600,
                                fontSize: "16px",
                                lineHeight: "20px"
                            })}
                            onClick={handlePaymentFalsePopup}
                        >
                            Go To Dashboard
                        </Button>
                    </Box>
                </Box>

            </Dialog>
        </>
    )
}
